import { Button, ButtonProps } from "@chakra-ui/react";
import React from "react";
import { CopyFormProps, useCopyForm } from "../../hooks/useCopyForm";

interface PasteFormButtonProps<T> {
  hooksProps: CopyFormProps<T>;
  children?: React.ReactNode;
}

export function PasteFormButton<T>({
  children,
  hooksProps,
  ...btnProps
}: PasteFormButtonProps<T> & ButtonProps) {
  const { pasteForm } = useCopyForm<T>(hooksProps);

  return (
    <Button
      colorScheme="cherryButton"
      {...btnProps}
      type="button"
      onClick={pasteForm}
    >
      {children ?? "Paste Form"}
    </Button>
  );
}
